import { Space } from 'antd';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { PersonalizationTag } from '../Personalization.Summary/PersonalizationTag';
import { TitledSection } from './TitledSection';
import { BaselinePersonalizationTablePanel } from './BaselinePersonalizationTablePanel';
import { useBaselinePersonalizationData } from './useBaselinePersonalizationData';
import { useBaselinePersonalizationColumns } from './useBaselinePersonalizationColumns';

interface Props {
  homeId: string;
  projectIds?: string[] | null;
  className?: string;
}

export function BaselinePanel(props: Props) {
  const { className } = props;
  const { t } = useTranslation(undefined, {
    keyPrefix: 'personalization.summary',
  });

  const { loading, floorplanData, wholeHomeData, roomsData, inactiveData } =
    useBaselinePersonalizationData(props);

  const floorplanColumns = useBaselinePersonalizationColumns(true);
  const roomColumns = useBaselinePersonalizationColumns(false);
  const inactiveColumns = useBaselinePersonalizationColumns(false);

  return (
    <div className={className}>
      {!isEmpty(floorplanData) && (
        <TitledSection
          className="mb-5 w-100"
          title={t('floorplanPersonalizations')}
        >
          <BaselinePersonalizationTablePanel
            columns={floorplanColumns}
            dataSource={floorplanData}
            name="Baseline_FloorplanPersonalizations"
            loading={loading}
          />
        </TitledSection>
      )}

      {!isEmpty(wholeHomeData) && (
        <TitledSection
          className="mb-5 w-100"
          title={t('wholeHomePersonalizations')}
        >
          <BaselinePersonalizationTablePanel
            columns={roomColumns}
            dataSource={wholeHomeData}
            name="Baseline_WholeHomePersonalizations"
            loading={loading}
          />
        </TitledSection>
      )}

      {!isEmpty(roomsData) && (
        <TitledSection
          className="mb-3 w-100"
          title={t('wholeHomePersonalizations')}
        >
          {roomsData.map((group) => (
            <Space direction="vertical" size="large" className="w-100 mb-3">
              <PersonalizationTag value={group.roomName!} />
              <BaselinePersonalizationTablePanel
                key={group.roomName}
                columns={roomColumns}
                dataSource={group.value}
                name={`Baseline_Room_${group.roomName}`}
                loading={loading}
              />
            </Space>
          ))}
        </TitledSection>
      )}

      {!isEmpty(inactiveData) && (
        <BaselinePersonalizationTablePanel
          columns={inactiveColumns}
          dataSource={inactiveData}
          name="Baseline_InactivePersonalizations"
          loading={loading}
        />
      )}
    </div>
  );
}
